export default __webpack_public_path__ + "static/media/1.c5c3cf3b.png";